import React from 'react'
import Box from '@mui/material/Box'
import { Dialog, DialogContent, DialogTitle, IconButton, SvgIcon, Typography, useMediaQuery } from '@mui/material'
import CloseIcon from '../../../../../static/Close-light.svg'
import { useTheme } from '@mui/material/styles'
import Image from '../../Image'
import { DialogImageProps } from './DialogImage.types'

const DialogImage = ({ image, alt, handleClose, open, visualDescription }: DialogImageProps) => {
  const { palette, breakpoints } = useTheme()

  const styles = {
    root: {
      '& .MuiBackdrop-root': {
        cursor: 'pointer',
        backgroundColor: 'rgba(26, 26, 26, 0.6)',
      },

      [breakpoints.down('sm')]: {
        '& .MuiDialog-container': {
          [breakpoints.down('sm')]: {
            maxWidth: '45ch',
            width: '100%',
            maxHeight: '100vh',
          },
        },
        '& .MuiDialog-paper': {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
      },
    },
    dialogContent: {
      padding: '0 0 1px 0',
      '& > div': {
        height: 'auto',
        borderRadius: '6px',
      },
    },
    visualDescription: {
      background: palette.grey[300],
      textAlign: 'center',
    },
    borderstyle: {
      borderRadius: '6px',
      maxHeight: '75vh',
      width: '100%',
      height: '100%',
    },
  }
  const isMobile = useMediaQuery(useTheme().breakpoints.down('sm'))
  return (
    <Dialog open={open} onClose={handleClose} sx={styles.root} fullScreen={isMobile}>
      <DialogTitle>
        <IconButton onClick={handleClose}>
          <SvgIcon component={CloseIcon} viewBox="0 0 48 48" />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={styles.dialogContent}>
        <Box>
          <Image {...image} description={alt} imageStyles={styles.borderstyle} />
          {visualDescription?.visualDescription && (
            <Typography sx={styles.visualDescription}>{visualDescription?.visualDescription}</Typography>
          )}
        </Box>
      </DialogContent>
    </Dialog>
  )
}
export default DialogImage
